


export type ArchivedMediaType = 'Document' | 'Image';

export const ArchivedMediaType = {
    Document: 'Document' as ArchivedMediaType,
    Image: 'Image' as ArchivedMediaType
};

